export const SHORTTIME_MAX_CHARS = 6 // nb of chars for the short version
export const SHORTTIME_MAX_INT = Number.parseInt(
	'9'.repeat(SHORTTIME_MAX_CHARS),
)

export default class ShortTime {
	_tm
	static get shortLength() {
		return SHORTTIME_MAX_CHARS
	}
	constructor(tm = undefined, chopMS = false) {
		var val = tm || Date.now()
		if (chopMS) val = Math.round(val / 1000) * 1000
		this._tm = val
	}
	get tm() {
		return this._tm
	}
	set tm(val) {
		this._tm = val
	}
	get tmStr() {
		return Math.round(this._tm / 1000).toString()
	}
	get str() {
		// return the date / time, as a string (to be displayed as an helper)
		return new Date(this._tm).toLocaleString('en-GB', {
			timezone: 'Europe/Paris',
			dateStyle: 'short',
			timeStyle: 'short',
		})
	}
	get utcStr() {
		// return the UTC date / time, as a string
		return new Date(this._tm).toUTCString()
	}
	get long() {
		return this._tm
	}
	set long(val) {
		this._tm = val
	}
	get prefix() {
		return Number.parseInt(
			this.tmStr.substring(0, this.tmStr.length - SHORTTIME_MAX_CHARS),
		)
	}
	get msec() {
		return this._tm - Math.round(this._tm / 1000) * 1000
	}
	get short() {
		// get a shorter time expression
		return Number.parseInt(
			this.tmStr.substring(this.tmStr.length - SHORTTIME_MAX_CHARS),
			10,
		)
	}
	set short(sec) {
		// update time by adding seconds
		this._tm = Number.parseInt(
			this.prefix.toString() +
				sec.toString().padStart(SHORTTIME_MAX_CHARS, '0') +
				this.msec.toString().padStart(3, '0'),
			10,
		)
	}
}
